import { CopyAddress } from '../components/CopyAddress';
import { ESSENCE_CONTRACTS, USDC_BASE, BASE_CHAIN_LABEL } from '../lib/contracts';

export default function ContractsPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-essence-gold">
        Contracts
      </p>
      <h1 className="mt-3 max-w-3xl font-display text-4xl font-bold tracking-tight text-essence-ink sm:text-5xl">
        Live on {BASE_CHAIN_LABEL}
      </h1>
      <p className="mt-5 max-w-2xl text-lg leading-relaxed text-essence-mute">
        Official Self Labs / Role Model Essence contracts. Verify every address on Basescan before interacting.
        Treasury may be unfunded; on-chain supply may be zero.
      </p>

      <div className="mt-10 grid gap-4">
        {ESSENCE_CONTRACTS.map((c) => (
          <CopyAddress key={c.address} contract={c} />
        ))}
      </div>

      <div className="mt-8">
        <p className="mb-3 text-sm font-medium text-essence-mute">Reference asset</p>
        <CopyAddress contract={USDC_BASE} />
      </div>

      <div className="mt-12 space-y-4 text-sm leading-relaxed text-essence-mute">
        <p>
          <span className="font-semibold text-essence-ink">Mint path:</span> EssenceBridge is the only minter.
          Owner / voucher signer today is the deployer ops wallet — describe this as admin/bridge-controlled mint,
          not a fair launch.
        </p>
        <p>
          <span className="font-semibold text-essence-ink">Withdraw:</span> On-chain mint requires a funded
          EssenceTreasury and a Concierge-signed withdraw voucher. Cloud ledger credits do not imply tokens already
          exist on-chain.
        </p>
        <p>
          <span className="font-semibold text-essence-ink">Not yet:</span> Public exchange listing, ungated consumer
          mint, or phones minting ESSENCE directly.
        </p>
      </div>
    </div>
  );
}
